import { AppModal } from '../AppModal';
import { youtubeEmbedUrl } from './youtube-url';

type YoutubeVideoModalProps = {
  videoId: string;
  open: boolean;
  onClose: () => void;
  title: string;
};

export function YoutubeVideoModal({
  videoId,
  open,
  onClose,
  title,
}: YoutubeVideoModalProps) {
  return (
    <AppModal
      isOpen={open}
      onClose={onClose}
      title={title}
      hideFooter
      size="6xl"
      motionPreset="none"
      className="youtube-video-modal"
    >
      {open ? (
        <div className="youtube-video-player">
          <iframe
            src={youtubeEmbedUrl(videoId)}
            title={title}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
            referrerPolicy="strict-origin-when-cross-origin"
          />
        </div>
      ) : null}
    </AppModal>
  );
}
